import { render, staticRenderFns } from "./look.vue?vue&type=template&id=3b13db7e&scoped=true"
import script from "./look.js?vue&type=script&lang=js&external"
export * from "./look.js?vue&type=script&lang=js&external"
import style0 from "./look.scss?vue&type=style&index=0&id=3b13db7e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13db7e",
  null
  
)

export default component.exports